
/**
 * SVG representation of the GitLab logo (in color).
 */
const AuthLoginMethodLogoGitLab = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 36 36" role="img" aria-hidden="true">
    <path
      fill="#E24329"
      fillRule="evenodd"
      d="M18 29.13l4.42-13.59H13.6l4.42 13.6z"
      clipRule="evenodd"
    />
    <path
      fill="#FC6D26"
      fillRule="evenodd"
      d="M18 29.13l-4.4-13.59H7.4L18 29.14z"
      clipRule="evenodd"
    />
    <path
      fill="#FCA326"
      fillRule="evenodd"
      d="M7.4 15.54l-1.34 4.13c-.12.38.01.8.33 1.02l11.62 8.44L7.4 15.54z"
      clipRule="evenodd"
    />
    <path
      fill="#E24329"
      fillRule="evenodd"
      d="M7.4 15.54h6.2l-2.67-8.18a.46.46 0 00-.87 0L7.4 15.54z"
      clipRule="evenodd"
    />
    <path
      fill="#FC6D26"
      fillRule="evenodd"
      d="M18 29.13l4.42-13.59h6.2L18 29.14z"
      clipRule="evenodd"
    />
    <path
      fill="#FCA326"
      fillRule="evenodd"
      d="M28.61 15.54l1.34 4.13a.91.91 0 01-.33 1.02l-11.61 8.44 10.6-13.59z"
      clipRule="evenodd"
    />
    <path
      fill="#E24329"
      fillRule="evenodd"
      d="M28.61 15.54h-6.19l2.66-8.18a.46.46 0 01.87 0l2.66 8.18z"
      clipRule="evenodd"
    />
  </svg>
);

export default AuthLoginMethodLogoGitLab;
